import { Component } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";

import { UserService, ExchangeService, WindowService, BaseComponent } from "@mypxplat/xplat/core";
import { AppService, FirebaseService } from "@mypxplat/xplat/web/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "fui-my-fender-welcome",
  templateUrl: "my-fender-welcome.component.html",
  standalone: false,
})
export class MyFenderWelcomeComponent extends BaseComponent {
  public step: number = 1;
  public isInitialLoad: boolean = true;
  public contentVisible: boolean = false;
  public showRestOfUI: boolean = false;
  public isFirstContentShow: boolean = true;
  public stepsArray: any[] = [1, 2, 3, 4, 5];
  public steps: any = {
    1: {
      header: this.translateService.instant("my_fender_welcome.welcome_to_myfender"),
      content: `<div class='t-20 bold text-center m-y-20'>${this.translateService.instant("my_fender_welcome.step1")}</div>`,
    },
    2: {
      header: this.translateService.instant("my_gear.register_your_gear"),
      content: `<div class='t-20 bold text-center m-y-20'>${this.translateService.instant("my_fender_welcome.step2")}</div><div class="d-flex align-items-end"><img class="p-x-10" src="./assets/images/register-fender-gear.png" alt="Fender Gear" /><img class="p-x-10" src="./assets/images/fsp8-images/fsp-subscription-box.png" alt="PreSonus Software" /><img class="p-x-10" src="./assets/images/register-presonus-hardware.png" alt="PreSonus Hardware" /></div>`,
    },
    3: {
      header: this.translateService.instant("my_fender_welcome.learn_from_best"),
      content: `<div class='t-20 bold text-center m-y-20'>${this.translateService.instant("my_fender_welcome.step3")}</div><div class="d-flex align-items-end"><img src="https://i.ytimg.com/vi/mKn0gMH7qOs/hqdefault.jpg" class="p-x-10 border-radius10" /><img src="https://i.ytimg.com/vi/2n291QtNnqw/hqdefault.jpg" class="p-x-10 border-radius10" /><img src="https://i.ytimg.com/vi/oDAknaJ9Kpo/hqdefault.jpg" class="p-x-10 border-radius10" /></div>`,
    },
    4: {
      header: this.translateService.instant("my_fender_welcome.connect_with_others"),
      content: `<div class='t-20 bold text-center m-y-20'>${this.translateService.instant("my_fender_welcome.step4")}</div><img src="${this.appService.activeTheme == "dark" ? "./assets/images/community-example-dark.png" : "./assets/images/community-example-light.png"}" />`,
    },
    5: {
      header: this.translateService.instant("education.get_started"),
      content: "",
    },
  };
  public initialAnimationDone: boolean = false;
  public shouldAnimateInFromRight: boolean = false;
  public shouldAnimateInFromLeft: boolean = false;
  constructor(
    userService: UserService,
    public windowService: WindowService,
    public activeModal: NgbActiveModal,
    public exchangeService: ExchangeService,
    public appService: AppService,
    public db: AngularFirestore,
    public translateService: TranslateService,
    public fbService: FirebaseService
  ) {
    super(userService);
  }

  ngOnInit() {
    if (this.userService.user.presonus_cognito_user_id) {
      let imgSrc = this.appService.activeTheme == "dark" ? "./assets/images/presonus_logo.png" : "./assets/images/presonus_logo_black.png";
      this.steps[1].content += `
        <div class="m-b-20 m-t-30 text-center">
          <img src="${imgSrc}" style="width: 100px; height: auto; margin: auto;" /><br />
          ${this.translateService.instant("my_fender_welcome.myfender_replaces_mypresonus")}
        </div>
      `;
    }
    this.windowService.setTimeout(() => {
      this.initialAnimationDone = true;
    }, 2000);

    this.fbService.doc("user_metadata/" + this.user.id).set(
      {
        sphere_announcements: {
          my_fender_welcome: true,
        },
      },
      { merge: true }
    );
  }

  changeStep(newStep: number) {
    if (newStep !== this.step) {
      if (newStep > this.step) {
        this.shouldAnimateInFromRight = true;
      } else {
        this.shouldAnimateInFromLeft = true;
      }
      this.step = newStep;
      this.windowService.setTimeout(() => {
        this.shouldAnimateInFromRight = false;
        this.shouldAnimateInFromLeft = false;
      }, 400);
    }
  }
}
